import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';

const LoupeItemHeaderComponent = (props) => {

    const currentItem = props.currentItem;

    const componentLabel = currentItem.label + (currentItem.required ? '*' : '');

    return (

        <>
            <Typography variant="h6" className="text-start mb-4" gutterBottom component="div">{componentLabel}</Typography>                        
            { currentItem.body != "" && 
                <Typography variant="body2" className="text-start mb-6" gutterBottom component="div">{currentItem.body}</Typography>               
            }
        </>

    );

}
export default LoupeItemHeaderComponent;